module.exports = __webpack_public_path__ + "94ca88fe9cbda2ffe4d12b0a342a40e4.pdf";